import { makeStyles } from '../../utils/makeStyles';
import React, { useContext, useRef, useState } from 'react';
import isEmail from 'validator/lib/isEmail';
import { ThemeContext } from '../../contexts/theme-context';
import ContactUI from '../core-ui/contacts/contacts-ui';
import { initializeApp } from 'firebase/app';
import { getFirestore, serverTimestamp, collection, addDoc } from 'firebase/firestore';

const firebaseConfig = {
  // Add your Firebase configuration here
   apiKey: "AIzaSyDdiRzVcBIaFZ0PWp_HPtb0Xcc_BD9uZBE",
  authDomain: "mavinsandeep-7.firebaseapp.com",
  projectId: "mavinsandeep-7",
  storageBucket: "mavinsandeep-7.firebasestorage.app",
  messagingSenderId: "920073889057",
  appId: "1:920073889057:web:ca25f0ae126d97e1418a60",
  measurementId: "G-MW7DYVG74J"
};

const isFirebaseConfigured = Boolean(firebaseConfig.projectId);
const db = isFirebaseConfigured ? getFirestore(initializeApp(firebaseConfig)) : null;

const Contacts = () => {
  const [open, setOpen] = useState(false);

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [success, setSuccess] = useState(false);
  const [errMsg, setErrMsg] = useState('');
  const form = useRef();
  const { theme } = useContext(ThemeContext);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  const useStyles = makeStyles((t) => ({
    input: {
      border: `2px solid ${theme.buttonColor}`,
      backgroundColor: `${theme.secondary}`,
      color: `${theme.tertiary}`,
      fontFamily: 'var(--primaryFont)',
      fontWeight: 500,
      transition: 'border 0.2s ease-in-out',
      '&:focus': {
        border: `2px solid ${theme.primary}`,
      },
    },
    message: {
      border: `2px solid ${theme.buttonColor}`,
      backgroundColor: `${theme.secondary}`,
      color: `${theme.tertiary}`,
      fontFamily: 'var(--primaryFont)',
      fontWeight: 500,
      transition: 'border 0.2s ease-in-out',
      '&:focus': {
        border: `2px solid ${theme.primary}`,
      },
    },
    label: {
      backgroundColor: `${theme.secondary}`,
      color: `${theme.tertiary}`,
      fontFamily: 'var(--primaryFont)',
      fontWeight: 600,
      fontSize: '0.9rem',
      padding: '0 5px',
      transform: 'translate(25px,50%)',
      display: 'inline-flex',
    },
    socialIcon: {
      width: '45px',
      height: '45px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '21px',
      backgroundColor: theme.buttonColor,
      color: theme.secondary,
      transition: '250ms ease-in-out',
      '&:hover': {
        transform: 'scale(1.1)',
        color: theme.secondary,
        backgroundColor: theme.primary,
      },
    },
    detailsIcon: {
      backgroundColor: theme.buttonColor,
      color: theme.secondary,
      borderRadius: '50%',
      width: '45px',
      height: '45px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '23px',
      transition: '250ms ease-in-out',
      flexShrink: 0,
      '&:hover': {
        transform: 'scale(1.1)',
        color: theme.secondary,
        backgroundColor: theme.primary,
      },
    },
    submitBtn: {
      backgroundColor: theme.primary,
      color: theme.secondary,
      transition: '250ms ease-in-out',
      '&:hover': {
        transform: 'scale(1.08)',
        color: theme.secondary,
        backgroundColor: theme.buttonColor,
      },
    },
  }));

  const classes = useStyles();

  const handleContactForm = async (e) => {
    e.preventDefault();

    if (name && email && message) {
      if (isEmail(email)) {
        if (!db) {
          setErrMsg('Contact form backend is not configured yet. Please email me directly.');
          setOpen(true);
          return;
        }

        const responseData = {
          Name: name,
          Email: email,
          Message: message,
          Time: serverTimestamp(),
        };

        try {
          await addDoc(collection(db, 'Message'), responseData);
          setSuccess(true);
          setErrMsg('Message sent successfully.');
          setOpen(true);
        } catch (error) {
          setErrMsg('Unable to send message right now. Please try again later.');
          setOpen(true);
        }
      } else {
        setErrMsg('Invalid email.');
        setOpen(true);
      }
    } else {
      setErrMsg('Please fill out all fields.');
      setOpen(true);
    }
  };

  return (
    <ContactUI
      open={open}
      success={success}
      errMsg={errMsg}
      handleClose={handleClose}
      classes={classes}
      handleContactForm={handleContactForm}
      name={name}
      setName={setName}
      form={form}
      email={email}
      setEmail={setEmail}
      message={message}
      setMessage={setMessage}
    />
  );
};

export default Contacts;
